import { render, staticRenderFns } from "./DetailUserForm.vue?vue&type=template&id=bd6f2b96&scoped=true&"
import script from "./DetailUserForm.vue?vue&type=script&lang=js&"
export * from "./DetailUserForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailUserForm.vue?vue&type=style&index=0&id=bd6f2b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f2b96",
  null
  
)

export default component.exports